import { SelectInputProps as SelectInputRaProps, SelectInput as SelectInputRA } from 'react-admin';

import WithInfoTooltip from 'src/components/WithInfoTooltip';
import { CommonInputProps } from './types';

interface SelectInputProps extends SelectInputRaProps, CommonInputProps {}

export const SelectInput = ({ infoTooltip, sx, ...rest }: SelectInputProps) => {
  const inputProps = {
    sx: {
      flex: infoTooltip ? 1 : undefined,
      ...sx,
    },
    ...rest,
  };

  if (!infoTooltip) return <SelectInputRA {...inputProps} />;

  return (
    <WithInfoTooltip title={infoTooltip} sx={{ ml: 1 }}>
      <SelectInputRA {...inputProps} />
    </WithInfoTooltip>
  );
};

export default SelectInput;
